import { Box, Button, useMediaQuery, useTheme, TextField } from "@mui/material";
import { DataGrid, esES, GridToolbar } from "@mui/x-data-grid";
import useAuth from "../../../../auth/useAuth";
import Header from "../../../../components/Header";
import { useFetchGET } from "../../../../state/FetchHelpers";
import Loading from "../../../global/Loading";
import FatalError from "../../../global/FatalError";
import AddIcon from '@mui/icons-material/Add';
import { tokens } from "../../../../theme";
import { useState } from "react";
import * as yup from "yup";
import { Formik } from "formik"
import ToggleOnOutlinedIcon from '@mui/icons-material/ToggleOnOutlined';
import ToggleOffOutlinedIcon from '@mui/icons-material/ToggleOffOutlined';
import { customerChannelList } from "../../../../config";
import { useCommunicationChannelCustomer } from "../../../hooks/catalog/useCommunicationChannelCustomer.tsx";
import EditIcon from '@mui/icons-material/Edit';
import ChannelDialog from "../../../dialogs/communicationChanel/ChannelDialog.tsx";

const CommunicationChannelCustomer = () => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode)
    const auth = useAuth();
    const token = auth.globals.token

    const isNonMobile = useMediaQuery("(min-width:600px)");
    const [openDialog, setOpenDialog] = useState(false);
    const [channelEdit, setChannelEdit] = useState(null);

    const handleCloseDialog = () => {
        setChannelEdit(null);
        setOpenDialog(false);
    };


    const [loadingRequest, setLoadingRequest] = useState(false)
    const [errorRequest, setErrorRequest] = useState(null)
    const statusOptions = [
        { id: 1, name: 'Activo' },
        { id: 0, name: 'Inactivo' },
    ];

    const cambiarStatus = (data) => {
        const newData = data.map((item) => {
            const statusOption = statusOptions.find((option) => option.id === item.status);
            if (statusOption) {
                return { ...item, status: statusOption.name };
            }
            return item;
        });
        return newData;
    };

    const {
        registerNewChannel,
        updateCommunicationChannelCustomer,
    } = useCommunicationChannelCustomer();

    const [refreshKey, setRefreshKey] = useState(0);

    const customerChannelURL = customerChannelList();

    const {
        data: customerChannelData,
        loading: customerChannelDataLoading,
        error: customerChannelDataError
    } = useFetchGET(customerChannelURL + '?refresh=' + refreshKey, token, []);



    // Luego, para forzar la recarga:
    const handleReload = () => {
        setRefreshKey(prev => prev + 1);
    };
    const [initialValues, setInicitalValues] = useState({
        name: "",
        description: "",
        status: "1"
    })

    const userSchema = yup.object().shape({
        //description: yup.string().required("* Valor Requerido"),
        name: yup.string().required("* Valor Requerido"),
    })


    const handleFormSubmit = (values, { resetForm }) => {
        setInicitalValues(values)
        setLoadingRequest(true)
        newChannel(values, resetForm)
    }

    const newChannel = async (values, resetForm) => {
        setLoadingRequest(true)
        const data = await registerNewChannel(values);
        setLoadingRequest(false)
        if (data === undefined) {
            setErrorRequest(true);
        } else {
            handleReload();
            resetForm();
            const init = {
                name: "",
                description: "",
                status: "1"
            }
            setInicitalValues(init);
        }
    };

    const changeStatus = async (status, updateChannel) => {
        const payload = {
            ...updateChannel,
            status: status,
        };
        setLoadingRequest(true)
        const data = await updateCommunicationChannelCustomer(payload.customer_acquisition_channel_id, payload);
        setLoadingRequest(false)
        if (data === undefined) {
            setLoadingRequest(false);
        } else {
            setLoadingRequest(false);
            handleReload();
        }
    };

    const handleSaveChannel = async (payload) => {
    if (payload) {
      setLoadingRequest(true)
      await updateCommunicationChannelCustomer(payload.customer_acquisition_channel_id, payload);
      setLoadingRequest(false)
      handleReload();
    }
  };


    const handleEditChannel = async (channel) => {
        setChannelEdit(channel);
        setOpenDialog(true);
    }

    const columns = [
        {
            field: "customer_acquisition_channel_id",
            headerName: "ID",
            flex: 0.25,
            cellClassName: "id-column--cell",
            headerClassName: "id-header--cell",
            hideable: false
        },
        {
            field: "name",
            headerName: "Nombre",
            flex: 0.75,
            cellClassName: "name-column--cell",
            minWidth: 120
        },
        {
            field: "description",
            headerName: "Descripción",
            flex: 0.75,
            cellClassName: "description-column--cell",
            minWidth: 120
        },
        {
            minWidth: 100,
            filterable: false,
            sortable: false,
            field: "status",
            headerName: "Opciones",
            headerAlign: "center",
            flex: 0.5,
            cellClassName: "status-column--cell",
            renderCell: ({ row }) => {
                return (
                    <Box
                        width="80%"
                        maxWidth="175px"
                        height="75%"
                        maxHeight="35px"
                        display="flex"
                        justifyContent="center"
                        m="0 auto">
                        {row.status === 'Activo'
                            ? <Box display="flex" gap={1}>
                                <Button
                                    color="secondary"
                                    size="small"
                                    variant="contained"
                                    startIcon={<EditIcon />}
                                    onClick={() => handleEditChannel(row)}
                                >Editar</Button>

                                <Button
                                    //estado==='Activo'?<Button
                                    color="success"
                                    variant="contained"
                                    onClick={() => { changeStatus("0", row) }}>
                                    <ToggleOffOutlinedIcon />
                                    <Box sx={{ ml: "5px" }}>
                                        Activo
                                    </Box>
                                </Button>

                            </Box>

                            : <Button
                                color="warning"
                                variant="contained"
                                onClick={() => { changeStatus("1", row) }}>
                                <ToggleOnOutlinedIcon />
                                <Box sx={{ ml: "5px" }}>
                                    Inactivo
                                </Box>
                            </Button>}
                    </Box>
                )
            }
        }
    ]

    if (loadingRequest || customerChannelDataLoading)
        return (<Loading />)

    if (errorRequest || customerChannelDataError)
        return (<FatalError />)


    return (
        <Box p={1} >
            {/*<Box display="flex" justifyContent="space-between" alignItems="center">*/}
            {<Header title="Canales de comunicación" subtitle="Listado de medios de contacto" />}
            <Formik
                enableReinitialize={true}
                onSubmit={handleFormSubmit}
                initialValues={initialValues}
                validationSchema={userSchema}
            >
                {({
                    values,
                    errors,
                    touched,
                    handleBlur,
                    handleChange,
                    handleSubmit,
                    setFieldValue,
                    resetForm
                }) => (
                    <form onSubmit={handleSubmit} >
                        <Box
                            display="grid"
                            gap="15px"
                            marginBottom="15px"
                            gridTemplateColumns="repeat(12, minmax(0, 1fr))"
                            sx={{
                                "& > div": { gridColumn: isNonMobile ? undefined : "span 12" }
                            }}
                        >
                            <TextField
                                fullWidth={!isNonMobile}
                                size="small"
                                variant="filled"
                                type="text"
                                label="Nombre"
                                onBlur={handleBlur}
                                onChange={handleChange}
                                value={values.name}
                                name="name"
                                error={!!touched.name && !!errors.name}
                                helperText={touched.name && errors.name}
                                sx={{ gridColumn: "span 4" }}
                            />
                            <TextField
                                fullWidth={!isNonMobile}
                                size="small"
                                variant="filled"
                                type="text"
                                label="Descripción"
                                onBlur={handleBlur}
                                onChange={handleChange}
                                value={values.description}
                                name="description"
                                error={!!touched.description && !!errors.description}
                                helperText={touched.description && errors.description}
                                sx={{ gridColumn: "span 8" }}
                            />
                        </Box>
                        <Box display="flex" justifyContent="end" mt="20px">
                            <Button type="submit" color="secondary" variant="contained">
                                <AddIcon />
                                Agregar nuevo canal
                            </Button>
                        </Box>
                    </form>
                )}
            </Formik>

            <Box m="5px 0px 50px 0" sx={{
                "& .MuiDataGrid-root": {
                    border: "none",
                },
                "& .MuiDataGrid-cell": {
                    borderBottom: "none"
                },
                "& .MuiDataGrid-columnHeaders": {
                    backgroundColor: colors.blueAccent[700],
                    borderBottom: "none",
                    color: "white"
                },
                "& .MuiDataGrid-virtualScroller": {
                    backgroundColor: colors.primary[400],
                },
                "& .MuiDataGrid-footerContainer": {
                    borderTop: "none",
                    backgroundColor: colors.blueAccent[700],
                },
                "& .MuiDataGrid-toolbarContainer .MuiButton-text": {
                    color: `${colors.grey[100]} !important`,
                },
                "& .MuiToolbar-gutters": {
                    color: "white"
                }

            }}>
                <DataGrid
                    autoHeight
                    initialState={{
                        columns: {
                            columnVisibilityModel: {
                                id: false,
                            },
                        },
                    }}
                    localeText={esES.components.MuiDataGrid.defaultProps.localeText}
                    rows={cambiarStatus(customerChannelData)}
                    columns={columns}
                    getRowId={(row) => row.customer_acquisition_channel_id}
                    density="compact"
                    slots={{
                        toolbar: GridToolbar,
                    }}

                />
            </Box>

            <ChannelDialog
                open={openDialog}
                onClose={handleCloseDialog}
                onSave={handleSaveChannel}
                item={channelEdit}
            />
        </Box>
    );


}

export default CommunicationChannelCustomer;